import { ValueOf } from 'type-fest'
import { z } from 'zod'

import { ApiErrorCodeZ } from './ErrorResponse'

export const ErrorCode = {
	...z.enum([
		'connection_error',
		'invalid_response',
		'invalid_state',
		'misconfiguration',
		'not_mapped', // The default error code in case of an AxiosError in the GetGoingClient
		'not_authenticated',
		'not_authorized',
		'server_error',
		'timeout',
		'too_many_requests',
		'unknown', // If nothing else suites use this one
	]).enum,
	...ApiErrorCodeZ.extract([
		'booking_error',
		'cancelled', // Use for AbortSignal, etc.
		'car_booking_error',
		'car_get_location_details_error',
		'credit_card_expired',
		'fare_unavailable',
		'result_expired',
		'send_sabre_command_error',
	]).enum,
} as const

export type ErrorCode = ValueOf<typeof ErrorCode>
